export default __webpack_public_path__ + "static/media/img-0754-slovenia-full-face.71d73478.png";